import { render, staticRenderFns } from "./ActivityInfo.vue?vue&type=template&id=613502bc&scoped=true"
import script from "./ActivityInfo.vue?vue&type=script&lang=js"
export * from "./ActivityInfo.vue?vue&type=script&lang=js"
import style0 from "./ActivityInfo.vue?vue&type=style&index=0&id=613502bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613502bc",
  null
  
)

export default component.exports